module.exports = __webpack_public_path__ + "static/media/29pic.71ed09b2.jpg";